import * as yup from 'yup';

export const editAdminUserFormValidator = yup.object({
  fullName: yup.string().nullable().required(),
  email: yup.string().email().nullable().required(),
});
